export default __webpack_public_path__ + "static/media/share-icon.dbeb9021.svg";